// utils/productTransformer.js - تبدیل‌کننده داده‌های محصول (Functional)
import { transformOfflineCartItemForDisplay } from '../../../helper';

/**
 * استخراج اطلاعات محصول
 * @param {Object} productData - داده‌های خام محصول
 * @returns {Object} - اطلاعات تمیز محصول
 */
export const extractProductInfo = (productData) => ({
  accounting_name_model: productData?.name || '',
  accounting_name_product: productData?.name || '',
  accounting_weight: productData?.weight || 0,
  accounting_barcode: productData?.barcode || '',
  album_id: productData?.album_id || '',
  weight: productData?.weight || 0,
});

/**
 * تبدیل محصولات localStorage به فرمت قابل استفاده
 * @param {Array} productsList - لیست محصولات از localStorage
 * @returns {Array} - محصولات تبدیل شده
 */
export const transformLocalStorageProducts = (productsList) => {
  if (!productsList || productsList === null) return [];

  return productsList.map(transformOfflineCartItemForDisplay);
};

/**
 * تولید URL محصول
 * @param {Object} product - محصول
 * @returns {string} - URL محصول
 */
export const generateProductUrl = (product) => {
  const albumId = product.products?.album_id || '';
  const productName = product.products?.accounting_name_product?.split(' ')?.join('-') || '';
  const weight = product.products?.weight || '';
  const barcode = product.products?.accounting_barcode || '';

  return `/products/${albumId}/${productName}?weight=${weight}&barcode=${barcode}`;
};

/**
 * بررسی وجود تخفیف
 * @param {Object} discount - اطلاعات تخفیف
 * @returns {boolean} - آیا تخفیف وجود دارد
 */
export const hasValidDiscount = (discount) => {
  return discount && discount.percent && discount.percent !== '' && discount.percent !== '0' && discount.sale_type === 'sale';
};

/**
 * فرمت کردن قیمت به تومان
 * @param {number} price - قیمت
 * @returns {string} - قیمت فرمت شده
 */
export const formatPrice = (price) => {
  return new Intl.NumberFormat('fa-IR').format(price / 10) + ' تومان';
};

/**
 * اعتبارسنجی داده‌های محصول
 * @param {Object} product - محصول
 * @returns {boolean} - آیا محصول معتبر است
 */
export const validateProduct = (product) => {
  return product && product.customers_basket_id && product.products && product.products.accounting_name_product && product.pictures && product.pictures.length > 0;
};

// Default export object برای سازگاری
const ProductTransformer = {
  transformLocalStorageProducts,
  extractProductInfo,
  generateProductUrl,
  hasValidDiscount,
  formatPrice,
  validateProduct,
};

export default ProductTransformer;
